const CaseDocumentInternalFlowStatusEnum = {
    HeadOfDepartmentResponded: 1,
    SentToAnotherDepartment: 2,
    SentToHead: 3,
    SentBack: 4,
    Resolved: 5

}
export default CaseDocumentInternalFlowStatusEnum
